export default __webpack_public_path__ + "8658b55c38e56ff4a8cd1fe96ac60e8d.svg";